import { render, staticRenderFns } from "./SEGEntrySearchResultDetail.vue?vue&type=template&id=52a3d554&"
import script from "./SEGEntrySearchResultDetail.vue?vue&type=script&lang=js&"
export * from "./SEGEntrySearchResultDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SEGEntrySearchResultDetail.vue"
export default component.exports